export enum MobileOS {
  IOS = 'iOS',
  ANDROID = 'Android',
}

export const useMobileOS = (): MobileOS => {
  const { userAgent } = navigator

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return MobileOS.IOS
  }
  return MobileOS.ANDROID
}
